import React from "react";
import { ImShare } from "react-icons/im";
import { IoShareSocial } from "react-icons/io5";
import { IoShareOutline } from "react-icons/io5";
import {
  Container,
  OrganizationName,
  PageName,
  QRCodeContainer,
  QRCodeImage,
  PoweredBy,
} from "./styled";

// It uses a series of regular expression tests (/regex/i.test(userAgent)) to check if the user agent string contains specific keywords related to different platforms
export const getDeviceIcon = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();

  if (/android/i.test(userAgent)) {
    return <IoShareSocial style={{ color: "#888", width: 40, height: 40 }} />;
  } else if (/iphone|ipod|ipad/i.test(userAgent)) {
    return <IoShareOutline style={{ color: "#888", width: 40, height: 40 }} />;
  } else if (/mac/i.test(userAgent)) {
    return <ImShare style={{ color: "#888", width: 40, height: 40 }} />;
  } else {
    return <IoShareSocial style={{ color: "#888", width: 40, height: 40 }} />;
  }
};
const QRCodeScreen = ({ organizationName, pageName, image, onShareButton }) => {
  const [imgLoaded, setImgLoaded] = React.useState(false);
  return (
    <Container>
      <OrganizationName>{organizationName}</OrganizationName>
      <PageName>{pageName}</PageName>
      <QRCodeContainer>
        <QRCodeImage
          src={image}
          alt="QR Code"
          onClick={onShareButton}
          data-loaded={imgLoaded ? "true" : "false"}
          onLoad={() => setImgLoaded(true)}
        />
      </QRCodeContainer>
      <PoweredBy as="div" onClick={onShareButton}>
        {getDeviceIcon()}
      </PoweredBy>
    </Container>
  );
};

export default QRCodeScreen;
